    document.addEventListener('click', function (event) {
  if (!event.target.classList.contains('upsell-variant-button')) return;

  const button = event.target;
  const wrapper = button.closest('.special-products-main');
  if (!wrapper) return;

  // Toggle active class for buttons
  button.parentElement.querySelectorAll('.upsell-variant-button').forEach(btn => btn.classList.remove('active'));
  button.classList.add('active');

  // Update displayed selected value
  const optionBlock = button.closest('.variant-option-block');
  const displaySpan = optionBlock.querySelector('.selected-option-value');
  if (displaySpan) displaySpan.textContent = button.dataset.value;

  // Collect all selected options
  const selectedOptions = [];
  wrapper.querySelectorAll('.variant-option-block').forEach((block, i) => {
    const activeButton = block.querySelector('.upsell-variant-button.active');
    selectedOptions[i] = activeButton ? activeButton.dataset.value : '';
  });

  // Find matched variant
  const variants = JSON.parse(wrapper.querySelector('[data-special-variants]').textContent);
  const matchedVariant = variants.find(variant =>
    variant.options.every((opt, i) => opt === selectedOptions[i])
  );
  if (!matchedVariant) return;

  // Update hidden input for Add to Cart
  const form = wrapper.querySelector('form[action^="/cart/add"]');
  const idInput = form ? form.querySelector('input[name="id"]') : null;
  if (idInput) idInput.value = matchedVariant.id;

  // Update price
  const priceElement = wrapper.querySelector('.special-variant-price');
  if (priceElement) {
    const currency = priceElement.dataset.currency || '';
    priceElement.textContent = matchedVariant.formatted_price + ' ' + currency;
  }

  // Update image
  const imageElement = wrapper.querySelector('.special-variant-image');
  if (imageElement) {
    let variantImage = null;

    // Check if variant has image object
    if (matchedVariant.image) {
      if (matchedVariant.image.src) {
        variantImage = matchedVariant.image.src;
      } else if (typeof matchedVariant.image === 'string') {
        variantImage = matchedVariant.image; // fallback if JSON just returned URL
      }
    }

    // Fallback: use first product image
    if (!variantImage) {
      const productImages = JSON.parse(wrapper.querySelector('[data-product-images]').textContent);
      if (productImages.length) variantImage = productImages[0].src;
    }

    // Set image src if available
    if (variantImage) {
      imageElement.src = variantImage.replace(/(\.jpg|\.png|\.webp)/, "_1024x1024$1");
    }
  }
});
